// extracted by mini-css-extract-plugin
export default {"menuContainer":"styles_menuContainer__F-bjN"};